import { Typography } from '@deliveryhero/pd-cookbook/components/Typography';
import { Box, Paper } from '@mui/material';

import { CallToActionsPorps } from './types';

export default function CallToActions({
  illustration,
  title,
  subtitle,
  children
}: CallToActionsPorps) {
  const Illustration = illustration;
  return (
    <Paper
      sx={{
        padding: '64px 0 64px 0',
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
        borderRadius: '8px'
      }}
    >
      {Illustration && (
        <Illustration width="200" height="200" data-testid="illustration-svg" />
      )}

      <Box
        sx={{
          mx: '195px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          textAlign: 'center'
        }}
      >
        <Typography type="title-lg" marginBottom="xs">
          {title}
        </Typography>
        <Typography type="paragraph-md">{subtitle}</Typography>
      </Box>

      {children && (
        <Box
          sx={{
            paddingTop: '24px',
            display: 'flex',
            gap: 10
          }}
        >
          {children}
        </Box>
      )}
    </Paper>
  );
}
